import { render } from "./VideoPlayerControlsContainer.vue?vue&type=template&id=6e3117e0&scoped=true"
import script from "./VideoPlayerControlsContainer.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsContainer.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsContainer.vue?vue&type=style&index=0&id=6e3117e0&lang=scss&scoped=true"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3117e0"]])

export default __exports__